import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import( /* webpackChunkName: "about" */ '../views/index.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/contact.vue')
  },
  {
    path: '/notice',
    name: 'notice',
    meta: {
      keepAlive: true,
    },
    component: () => import('@/views/notice.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('@/views/product.vue')
  },
  {
    path: '/noticeInfo',
    name: 'noticeInfo',
    component: () => import('@/views/noticeInfo.vue')
  },
  {
    path: '/merchantJoin',
    name: 'merchantJoin',
    component: () => import('@/views/merchantJoin.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router